import * as C from '../constants';
import TwentyService from '../../../services/twenty-service';
import CarrierTypes from '../../../variables/carrierTypes';

export default {
  /**
   * @param commit
   * @param payload
   * @returns {Promise<T>}
   */
  getSuppliersWithCurrencyBySupplierType({ commit }) {
    commit(C.NON_DYNAMIC_TRANSPORT_SUPPLIERS_PENDING);
    return TwentyService.getSuppliersWithCurrencyBySupplierType()
      .then((res) => {
        commit(C.NON_DYNAMIC_TRANSPORT_SUPPLIERS_SUCCESS, res.data);
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_SUPPLIERS_FAILURE);
      });
  },

  /**
   * @param commit
   * @returns {Promise<T | never>}
   */
  getTransitsByType({ commit }) {
    commit(C.NON_DYNAMIC_TRANSPORT_TRANSITS_PENDING);
    return TwentyService.getTransitsByType(CarrierTypes.AIRPORT)
      .then((res) => {
        commit(C.NON_DYNAMIC_TRANSPORT_TRANSITS_SUCCESS, res.data);
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_SUPPLIERS_FAILURE);
      });
  },

  /**
   * @param commit
   * @returns {Promise<T | never>}
   */
  getCarriers({ commit }) {
    commit(C.NON_DYNAMIC_TRANSPORT_CARRIERS_PENDING);
    return TwentyService.getCarriers()
      .then((res) => {
        if (res.status === 200) {
          commit(C.NON_DYNAMIC_TRANSPORT_CARRIERS_SUCCESS, res.data);
        } else if (res.status === 204) {
          commit(C.NON_DYNAMIC_TRANSPORT_CARRIERS_NO_CONTENT);
        }
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_CARRIERS_FAILURE);
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param transportId
   * @param payload
   * @returns {Promise<T | never>}
   */
  getNonDynamicTransport({ commit, dispatch }, transportId) {
    commit(C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_PENDING);
    return TwentyService.getNonDynamicTransport(transportId)
      .then((res) => {
        commit(C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_SUCCESS, res.data);
        dispatch('snackbar/show', {
          identifier: 'success',
          message: 'non_dynamic_transport_transport_get_success',
        }, { root: true });
        dispatch('getTransportLuggage', res.data.id);
        dispatch('getTransportContractsByTransportId', res.data.id);
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_FAILURE);
        dispatch('snackbar/show', {
          identifier: 'error',
          message: 'non_dynamic_transport_transport_get_error',
        }, { root: true });
      });
  },

  /**
   * @param commit
   * @returns {Promise<T | never>}
   */
  getNonDynamicTransports({ commit }) {
    function buildTransport(bound, days) {
      return {
        departure: bound[0].departureTransit.iataCode,
        departureFullname: bound[0].departureTransit.name,
        arrival: bound[bound.length - 1].arrivalTransit.iataCode,
        arrivalFullname: bound[bound.length - 1].arrivalTransit.name,
        stopOver: bound.slice(1, bound.length).map(
          transit => transit.departureTransit.iataCode,
        ).join(', '),
        stopOverFullname: bound.slice(1, bound.length).map(
          transit => transit.departureTransit.name,
        ).join(', '),
        days,
        carrier: bound[0].carrier.name,
        ref: bound[0].ref,
      };
    }

    commit(C.NON_DYNAMIC_TRANSPORT_GET_LIST_PENDING);
    return TwentyService.getNonDynamicTransports()
      .then((res) => {
        const transports = [];
        res.data.forEach((obj) => {
          const transport = {
            id: obj.id,
            type: obj.type,
            allotment: obj.allotment,
            fromDate: null,
            toDate: null,
            PNR: null,
            route: [],
            bound: '',
          };

          if (obj.outbound.length > 0 && obj.inbound.length > 0) {
            transport.bound = 'out-/inbound';
          } else if (obj.outbound.length) {
            transport.bound = 'outbound';
          } else if (obj.inbound.length) {
            transport.bound = 'inbound';
          }

          if (obj.allotments.length === 0) {
            transports.push(transport);
          } else {
            obj.allotments.forEach((allotment) => {
              const allotTransport = {
                ...transport,
                fromDate: allotment.fromDate,
                toDate: allotment.toDate,
                PNR: allotment.PNR,
                route: [],
              };
              if (obj.outbound.length) {
                allotTransport.route.push(buildTransport(obj.outbound, allotment.days.outbound));
              }
              if (obj.inbound.length) {
                allotTransport.route.push(buildTransport(obj.inbound, allotment.days.inbound));
              }
              transports.push(allotTransport);
            });
          }
        });
        commit(C.NON_DYNAMIC_TRANSPORT_GET_LIST_SUCCESS, transports);
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_GET_LIST_FAILURE);
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<T | never>}
   */
  saveBaseTransport({ commit, dispatch }, payload) {
    commit(C.NON_DYNAMIC_TRANSPORT_SAVE_TRANSPORT_PENDING);
    return TwentyService.saveBaseTransport(payload)
      .then((res) => {
        commit(C.NON_DYNAMIC_TRANSPORT_SAVE_TRANSPORT_SUCCESS, res.data);
        dispatch('snackbar/show', {
          identifier: 'success',
          message: 'non_dynamic_transport_transport_save_success',
        }, { root: true });
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_SAVE_TRANSPORT_FAILURE);
        dispatch('snackbar/show', {
          identifier: 'error',
          message: 'non_dynamic_transport_transport_save_error',
        }, { root: true });
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<T | never>}
   */
  saveSiblingTransport({ commit, dispatch }, payload) {
    commit(C.NON_DYNAMIC_TRANSPORT_SAVE_SIBLING_TRANSPORT_PENDING);
    return TwentyService.saveTransport(payload)
      .then((res) => {
        commit(C.NON_DYNAMIC_TRANSPORT_SAVE_SIBLING_TRANSPORT_SUCCESS, res.data);
        dispatch('snackbar/show', {
          identifier: 'success',
          message: 'non_dynamic_transport_transport_save_sibling_success',
        }, { root: true });
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_SAVE_SIBLING_TRANSPORT_FAILURE);
        dispatch('snackbar/show', {
          identifier: 'error',
          message: 'non_dynamic_transport_transport_save_sibling_error',
        }, { root: true });
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<T | never>}
   */
  uploadContracts({ commit, dispatch }, payload) {
    commit(C.NON_DYNAMIC_TRANSPORT_UPLOAD_CONTRACTS_PENDING);
    const { contracts, transportId } = payload;
    const formData = new FormData();
    contracts.forEach((contract) => {
      formData.append('files[]', contract);
    });
    return TwentyService.uploadContracts(transportId, formData)
      .then((res) => {
        if (res.status === 204) {
          commit(C.NON_DYNAMIC_TRANSPORT_UPLOAD_CONTRACTS_SUCCESS);
          dispatch('snackbar/show', {
            identifier: 'success',
            message: 'non_dynamic_transport_contract_save_success',
          }, { root: true });
        }
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_UPLOAD_CONTRACTS_FAILURE);
        dispatch('snackbar/show', {
          identifier: 'error',
          message: 'non_dynamic_transport_contract_save_error',
        }, { root: true });
      });
  },

  /**
   * @param commit
   * @returns {Promise<T | never>}
   */
  getTransportTripSeatingSectionTypes({ commit }) {
    commit(C.NON_DYNAMIC_TRANSPORT_SAVE_SIBLING_TRANSPORT_PENDING);
    return TwentyService.getTransportTripSeatingSectionTypes()
      .then((res) => {
        if (res.status === 200) {
          commit(C.NON_DYNAMIC_TRANSPORT_SEATING_SECTION_TYPES_SUCCESS, res.data);
        } else {
          commit(C.NON_DYNAMIC_TRANSPORT_SEATING_SECTION_TYPES_NO_CONTENT);
        }
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_SEATING_SECTION_TYPES_FAILURE);
      });
  },

  /**
   * @param commit
   * @returns {Promise<T | never>}
   */
  getTransportTripConsumableTypes({ commit }) {
    commit(C.NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_PENDING);
    return TwentyService.getTransportTripConsumableTypes()
      .then((res) => {
        if (res.status === 200) {
          commit(C.NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_SUCCESS, res.data);
        } else {
          commit(C.NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_NO_CONTENT);
        }
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_FAILURE);
      });
  },

  /**
   * @param commit
   * @returns {Promise<T | never>}
   */
  getTransportTripUpgradeTypes({ commit }) {
    commit(C.NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_PENDING);
    return TwentyService.getTransportTripUpgradeTypes()
      .then((res) => {
        if (res.status === 200) {
          commit(C.NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_SUCCESS, res.data);
        } else {
          commit(C.NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_NO_CONTENT);
        }
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_FAILURE);
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<T | never>}
   */
  syncTransportTripSeatings({ commit, dispatch }, payload) {
    commit(C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_SEATINGS_PENDING);
    return TwentyService.syncTransportTripSeatings(payload.tripId, payload.tripSeatings)
      .then((res) => {
        commit(C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_SEATINGS_SUCCESS, res.data);
        dispatch('snackbar/show', {
          identifier: 'success',
          message: 'non_dynamic_transport_trip_sync_seatings_success',
        }, { root: true });
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_SEATINGS_FAILURE);
        dispatch('snackbar/show', {
          identifier: 'error',
          message: 'non_dynamic_transport_trip_sync_seatings_error',
        }, { root: true });
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<T | never>}
   */
  syncTransportTripConsumables({ commit, dispatch }, payload) {
    commit(C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_CONSUMABLES_PENDING);
    return TwentyService.syncTransportTripConsumables(payload.tripId, payload.tripConsumables)
      .then((res) => {
        commit(C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_CONSUMABLES_SUCCESS, res.data);
        dispatch('snackbar/show', {
          identifier: 'success',
          message: 'non_dynamic_transport_trip_sync_consumables_success',
        }, { root: true });
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_CONSUMABLES_FAILURE);
        dispatch('snackbar/show', {
          identifier: 'error',
          message: 'non_dynamic_transport_trip_sync_consumables_error',
        }, { root: true });
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<T | never>}
   */
  syncTransportTripUpgrades({ commit, dispatch }, payload) {
    commit(C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_UPGRADES_PENDING);
    return TwentyService.syncTransportTripUpgrades(payload.tripId, payload.tripUpgrades)
      .then((res) => {
        commit(C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_UPGRADES_SUCCESS, res.data);
        dispatch('snackbar/show', {
          identifier: 'success',
          message: 'non_dynamic_transport_trip_sync_upgrades_success',
        }, { root: true });
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_UPGRADES_FAILURE);
        dispatch('snackbar/show', {
          identifier: 'error',
          message: 'non_dynamic_transport_trip_sync_upgrades_error',
        }, { root: true });
      });
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<T | never>}
   */
  getTransportTripSeatingsByTripId({ commit }, payload) {
    commit(C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_PENDING);
    return TwentyService.getTransportTripSeatingsByTripId(payload)
      .then((res) => {
        if (res.status === 200) {
          commit(C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_SUCCESS, res.data);
        } else {
          commit(C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_NO_CONTENT);
        }
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_FAILURE);
      });
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<T | never>}
   */
  getTransportTripConsumablesByTripId({ commit }, payload) {
    commit(C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_PENDING);
    return TwentyService.getTransportTripConsumablesByTripId(payload)
      .then((res) => {
        if (res.status === 200) {
          commit(C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_SUCCESS, res.data);
        } else {
          commit(C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_NO_CONTENT);
        }
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_FAILURE);
      });
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<T | never>}
   */
  getTransportTripUpgradesByTripId({ commit }, payload) {
    commit(C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_PENDING);
    return TwentyService.getTransportTripUpgradesByTripId(payload)
      .then((res) => {
        if (res.status === 200) {
          commit(C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_SUCCESS, res.data);
        } else {
          commit(C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_NO_CONTENT);
        }
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_FAILURE);
      });
  },

  /**
   * @param commit
   * @returns {Promise<T | never>}
   */
  getTransportLuggageTypes({ commit }) {
    commit(C.NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_TYPES_PENDING);
    return TwentyService.getTransportLuggageTypes()
      .then((res) => {
        commit(C.NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_TYPES_SUCCESS, res.data);
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_TYPES_FAILURE);
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<T | never>}
   */
  syncTransportLuggage({ commit, dispatch }, payload) {
    commit(C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_LUGGAGE_PENDING);
    return TwentyService.syncTransportLuggage(payload.transportId, payload.transportLuggage)
      .then((res) => {
        commit(C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_LUGGAGE_SUCCESS, res.data);
        dispatch('snackbar/show', {
          identifier: 'success',
          message: 'non_dynamic_transport_transport_luggage_sync_success',
        }, { root: true });
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_LUGGAGE_FAILURE);
        dispatch('snackbar/show', {
          identifier: 'error',
          message: 'non_dynamic_transport_transport_luggage_sync_error',
        }, { root: true });
      });
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<T | never>}
   */
  getTransportLuggage({ commit }, payload) {
    commit(C.NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_PENDING);
    return TwentyService.getTransportLuggage(payload)
      .then((res) => {
        if (res.status === 204) {
          commit(C.NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_NO_CONTENT);
        } else {
          commit(C.NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_SUCCESS, res.data);
        }
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_FAILURE);
      });
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<T | never>}
   */
  getTransportContractsByTransportId({ commit }, payload) {
    commit(C.NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_PENDING);
    return TwentyService.getTransportContractsByTransportId(payload)
      .then((res) => {
        if (res.status === 200) {
          commit(C.NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_SUCCESS, res.data);
        } else if (res.status === 204) {
          commit(C.NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_NO_CONTENT);
        }
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_FAILURE);
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<T | never>}
   */
  searchTransports({ commit, dispatch }, payload) {
    commit(C.NON_DYNAMIC_TRANSPORT_SEARCH_PENDING);
    return TwentyService.searchTransport(payload)
      .then((res) => {
        if (res.status === 200) {
          commit(C.NON_DYNAMIC_TRANSPORT_SEARCH_SUCCESS, res.data);
        } else if (res.status === 204) {
          commit(C.NON_DYNAMIC_TRANSPORT_SEARCH_NO_CONTENT);
          dispatch('snackbar/show', {
            identifier: 'warning',
            message: 'non_dynamic_transport_transport_search_no_content',
          }, { root: true });
        }
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_SEARCH_FAILURE);
        dispatch('snackbar/show', {
          identifier: 'error',
          message: 'non_dynamic_transport_transport_search_error',
        }, { root: true });
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<T | never>}
   */
  searchTransportPriceSettings({ commit, dispatch }, payload) {
    commit(C.NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_PENDING);
    return TwentyService.searchTransport(payload)
      .then((res) => {
        if (res.status === 200) {
          commit(C.NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_SUCCESS, res.data);
        } else if (res.status === 204) {
          commit(C.NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_NO_CONTENT);
          dispatch('snackbar/show', {
            identifier: 'warning',
            message: 'non_dynamic_transport_transport_search_no_content',
          }, { root: true });
        }
      }).catch(() => {
        commit(C.NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_NO_CONTENT);
        dispatch('snackbar/show', {
          identifier: 'error',
          message: 'non_dynamic_transport_transport_search_error',
        }, { root: true });
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/non-dynamic-transport/actions.js